import createReactComponent from '../createReactComponent';
export default createReactComponent('database-export', 'IconDatabaseExport', [
  ['path', { d: 'M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M4 6v6c0 1.657 3.582 3 8 3a19.84 19.84 0 0 0 3.302 -.267m4.698 -2.733v-6',
      key: 'svg-1',
    },
  ],
  [
    'path',
    {
      d: 'M4 12v6c0 1.599 3.335 2.905 7.538 3m8.462 -7v-2m-6 7h7m-3 -3l3 3l-3 3',
      key: 'svg-2',
    },
  ],
]);
